import { render } from "./SecondSliderArticle.vue?vue&type=template&id=5d8c6655&scoped=true"
import script from "./SecondSliderArticle.vue?vue&type=script&lang=js"
export * from "./SecondSliderArticle.vue?vue&type=script&lang=js"

import "./SecondSliderArticle.vue?vue&type=style&index=0&id=5d8c6655&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8c6655"]])

export default __exports__